import { t as createLogger } from "./app.shared-CmP4XLF_.js";

import { t as debounce } from "./app.shared-OQDvbu1B.js";

var log = createLogger("pdp-model-message-anchor");

var DESKTOP_MQ = "(min-width: 1025px)";

var EDGE_BUFFER_PX = 2;

var SOURCE = "pdp-model-message-anchor";

var NUDGE_EVENT = "global-ui:nudge";

var NUDGE_REQUEST_EVENT = "global-ui:nudge-request";

var pdp_model_message_anchor_default = (() => {
    const message = document.querySelector("[data-model-message-sticky]");
    if (!message) return;
    const pill = message.querySelector("[data-model-message-pill]") || message;
    const desktopMq = window.matchMedia(DESKTOP_MQ);
    let rafId = null;
    let stuck = false;
    let lastEdgeY = null;
    const emitEdge = (edgeY, force = false) => {
        if (!force && edgeY === lastEdgeY) return;
        lastEdgeY = edgeY;
        log("ui", "dispatch global-ui:nudge", {
            lane: "bottom-left",
            source: SOURCE,
            edgeY: edgeY
        });
        document.dispatchEvent(new CustomEvent(NUDGE_EVENT, {
            detail: {
                lane: "bottom-left",
                source: SOURCE,
                edgeY: edgeY
            }
        }));
    };
    const setStuck = nowStuck => {
        if (nowStuck === stuck) return;
        stuck = nowStuck;
        log("lifecycle", "model message stuck state changed", {
            stuck: stuck
        });
        if (!stuck) emitEdge(null);
    };
    const update = () => {
        if (!desktopMq.matches) {
            setStuck(false);
            return;
        }
        const rect = message.getBoundingClientRect();
        setStuck(Math.abs(rect.bottom - window.innerHeight) < 1);
        if (stuck) emitEdge(Math.floor(pill.getBoundingClientRect().top - EDGE_BUFFER_PX));
    };
    const scheduleUpdate = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(() => {
            rafId = null;
            update();
        });
    };
    document.addEventListener(NUDGE_REQUEST_EVENT, event => {
        const {lane: lane} = event.detail ?? {};
        if (lane !== "bottom-left" && lane !== "all") return;
        if (stuck) emitEdge(lastEdgeY, true);
    });
    window.addEventListener("scroll", scheduleUpdate, {
        passive: true
    });
    window.addEventListener("resize", debounce(scheduleUpdate, 150), {
        passive: true
    });
    desktopMq.addEventListener("change", scheduleUpdate);
    scheduleUpdate();
    log("lifecycle", "pdp model message anchor initialized");
})();